import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { userRoleItems } from "../../../utils/enum";

const useMenuData = () => {
  const auth = useSelector((state) => state.auth);
  const permissions = useSelector((state) => state.permissions);

  const [menu, setMenu] = useState([]);

  const admin = [
    {
      heading: "داشبورد",
      icon: "dashboard",
      subMenu: [
        {
          icon: "dashboard",
          text: "داشبورد",
          link: "/admin",
        },
        {
          icon: "list",
          text: "سفارشات",
          link: "/admin/orders",
        },
        {
          icon: "money",
          text: "بدهکاران",
          link: "/admin/debtors",
        },
      ],
    },
    {
      heading: "مدیریت",
      icon: "server",
      subMenu: [
        {
          icon: "users",
          text: "ادمین ها",
          permission: "canAdmins",
          link: "/admin/admins",
        },
        {
          icon: "user-circle",
          text: "مشتری ها",
          link: "/admin/customers",
        },
        {
          icon: "box",
          text: "محصولات",
          permission: "canProducts",
          link: "/admin/products",
        },
        {
          icon: "table-view",
          text: "میزها",
          permission: "canTables",
          link: "/admin/tables",
        },
        {
          icon: "ticket",
          text: "تنظیمات چوب",
          permission: "canTables",
          link: "/admin/cue",
        },
        {
          icon: "setting",
          text: "تنظیمات",
          permission: "canSetting",
          link: "/admin/setting",
        },
      ],
    },
    {
      heading: "گزارش ها",
      icon: "reports",
      subMenu: [
        {
          icon: "report-profit",
          text: "تراکنشات",
          link: "/admin/transactions",
        },
        {
          icon: "user-list",
          text: "رویدادنگاری",
          link: "/admin/logs",
        },
        {
          icon: "reports",
          text: "حسابداری",
          permission: "canAccounting",
          link: "/admin/accounting",
        },
        {
          icon: "coins",
          text: "هزینه ها",
          permission: "canAccounting",
          link: "/admin/costs",
        },
      ],
    },
  ];
  const filterMenuItems = (menuItems) => {
    return menuItems
      .map((menu) => {
        if (menu.permission && !permissions[menu.permission]) return null;

        if (menu.subMenu) {
          const filteredSubMenu = filterMenuItems(menu.subMenu);
          menu.subMenu = filteredSubMenu.filter((item) => item !== null);
          return menu.subMenu.length > 0 ? menu : null;
        }

        return menu;
      })
      .filter((menu) => menu !== null);
  };

  useEffect(() => {
    const items = { ADMIN: admin };
    setMenu(filterMenuItems(items[auth?.role || userRoleItems[0]]));
  }, [auth, permissions]);

  return menu;
};

export default useMenuData;
